import logo from './data/logoch.png';
import logoa from './data/logoa.png';
export default function MHeader() {

return (<table width="100%" border="0">
            <tr>
                <td  align="center"  valign="center">
                    <a href="#"><img   alt ="logoa" className="App-logo " src={logoa}></img></a>
                </td>
                <td align="left">
                    <h3>ISMC - Soluzioni innovative per la conservazione dei Paesaggi Stratificati attraverso monitoraggio e controllo remoto.
                    </h3>
                    CHANGES – Cultural Heritage Active Innovation for Sustainable Society”  – CUP B53C22003780006 - PIANO NAZIONALE DI RIPRESA E RESILIENZA (PNRR) - 
                    MISSIONE 4 COMPONENTE 2 INVESTIMENTO 1.3 – finanziato dall’Unione europea - NextGenerationEU – Bando a Cascata verso Enti Pubblici e/o Enti Privati
                </td>
                
                </tr>
        </table>
)
}